import { render } from "./LeaderboardWidget.vue?vue&type=template&id=2f29e7ec&scoped=true"
import script from "./LeaderboardWidget.vue?vue&type=script&lang=js"
export * from "./LeaderboardWidget.vue?vue&type=script&lang=js"

import "./LeaderboardWidget.vue?vue&type=style&index=0&id=2f29e7ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f29e7ec"]])

export default __exports__